import { render, staticRenderFns } from "./CarouselHeader.vue?vue&type=template&id=85f6da6e&scoped=true"
import script from "./CarouselHeader.vue?vue&type=script&lang=js"
export * from "./CarouselHeader.vue?vue&type=script&lang=js"
import style0 from "./CarouselHeader.vue?vue&type=style&index=0&id=85f6da6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f6da6e",
  null
  
)

export default component.exports